<template>
  <b-modal
    :id="id"
    :ok-title="trans('close')"
    ok-only
    size="lg"
    @shown="onShown"
  >
    <template v-slot:modal-title>
      <span>{{ trans('embed_on_your_website') }}</span>
    </template>

    <b-form-group :label="trans('page')">
      <page-dropdown
        :organization="organization"
        v-model="page_id"
        nullable
        :initial_short_url="page ? page.short_url : null"
        :placeholder="trans('home')"
        :disabled="busy"
      ></page-dropdown>
    </b-form-group>

    <b-form-group class="mt-3">
      <label>
        <strong>IFRAME</strong>
        <small class="d-block">{{ trans('embed_iframe_javascript_about') }}</small>
      </label>
      <b-form-textarea :value="iframe_code" size="sm" :rows="10" readonly></b-form-textarea>
      <b-row>
        <b-col>
          <small class="form-text text-muted">
            {{ trans('embed_on_your_webiste_security').replace(':url', url) }}
          </small>
        </b-col>
        <b-col class="col-2 text-right mt-2">
          <b-button v-if="!!iframe_code" variant="outline-primary" size="sm" v-clipboard:copy="iframe_code" class="px-2">
            <i class="fa fa-fw fa-copy"></i>
            {{ trans('copy') }}
          </b-button>
        </b-col>
      </b-row>
    </b-form-group>

    <p v-if="busy">
      <i class="fa fa-fw fa-circle-notch fa-spin"></i>
      {{ trans('please_wait') }}
    </p>
    <p v-if="error" class="text-danger">
      {{ error }}
    </p>
  </b-modal>
</template>

<script>
  import PageDropdown from './../page/PageDropdown'

  export default {
    props: {
      id: {
        type: String,
        default: 'page-iframe-embed-modal',
      },
      organization: Object,
      page: Object,
    },
    components: {
      PageDropdown,
    },
    data() {
      return {
        trans: trans,
        busy: false,
        error: null,
        iframe_code: null,
        page_id: null,
      }
    },
    computed: {
      url() {
        if (!this.organization.url) return null
        try {
          return (new URL(this.organization.url)).hostname
        } catch(e) {
          return null
        }
      },
    },
    watch: {
      page_id() {
        this.fetch()
      },
    },
    methods: {
      onShown() {
        this.page_id = this.page ? this.page_id : null
        this.iframe_code = null
        this.fetch()
      },
      fetch() {
        this.busy = false
        this.error = null
        let url = `/organization/${this.organization.id}/page/${this.page_id ? this.page_id : 'home'}/iframe_code`
        axios.get(url)
        .then(response => {
          this.busy = false
          this.iframe_code = response.data
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
    },
    mounted() {
      window.pageIframeModal = this
    },
  }
</script>